"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var autocomplete_menu_style_1 = require("../../components/autocomplete.menu/autocomplete.menu.style");
var menu_item_style_1 = require("../../components/menu/menu.item.style");
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-TagInput',
    filterMatch: 'c-TagInput__match',
    link: 'c-TagInput__link',
    title: 'c-TagInput__title',
    date: 'c-TagInput__date',
    linkEditable: 'c-TagInput__link--editable'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = (_b = {
            flex: '1 1',
            display: 'flex',
            position: 'relative'
        },
        _b["& .".concat(autocomplete_menu_style_1.CSS.container)] = {
            position: 'absolute',
            top: '100%',
            left: '0'
        },
        _b["& .".concat(autocomplete_menu_style_1.CSS.container, " .").concat(menu_item_style_1.CSS.item)] = {
            overflow: 'hidden',
            display: ' inline-block',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap',
            'text-align': 'left'
        },
        _b),
    _a[exports.CSS.date] = {
        color: theme_1.DefaultTheme.font.color.disabled,
        'line-height': theme_1.DefaultTheme.space(4),
        'font-size': '90%'
    },
    _a[exports.CSS.title] = {
        'line-height': theme_1.DefaultTheme.space(4)
    },
    _a[exports.CSS.filterMatch] = {
        fontWeight: theme_1.DefaultTheme.font.weight.bold
    },
    _a[exports.CSS.link] = {
        padding: "0 ".concat(theme_1.DefaultTheme.space(1)),
        flex: '1 1',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        cursor: 'pointer'
    },
    _a[exports.CSS.linkEditable] = {
        extend: exports.CSS.link,
        width: '100%',
        lineHeight: theme_1.DefaultTheme.space(6),
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontSize: theme_1.DefaultTheme.font.size,
        background: 'transparent',
        outline: 'none',
        border: 'none',
        borderBottom: "2px solid ".concat(theme_1.DefaultTheme.color.primary),
        cursor: 'text'
    },
    _a);
//# sourceMappingURL=tag.name.input.style.js.map